const set = require('regenerate')(0x1CD5, 0x1CE2, 0x1CE9, 0x1CEB, 0x1CED);
set.addRange(0x951, 0x952).addRange(0x1CD7, 0x1CD8).addRange(0x11400, 0x1145B).addRange(0x1145D, 0x11461);
exports.characters = set;
